export { GoogleAnalytics as NextGoogleAnalytics } from "./src/next-script";
